import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cette ligne force le navigateur à remonter instantanément tout en haut (X: 0, Y: 0)
    window.scrollTo(0, 0);
  }, [pathname]); // La fonction se déclenche dès que l'URL (pathname) change

  return null; // Ce composant est invisible, il ne renvoie pas de HTML
}

export default ScrollToTop;